/**
 * APIs que recebem os headers `sentry-trace` e `baggage` do Sentry.
 *
 * Só entram aqui as APIs cujo CORS aceita esses headers no preflight. Uma API que não
 * aceita derruba a requisição inteira no navegador (status 0, "Request header field
 * baggage is not allowed"). Hoje ficam de fora o mtr-manager e o contestacao-service;
 * inclua-os só depois de liberar `sentry-trace` e `baggage` no CORS deles.
 */
export interface TracePropagationEnv {
  VITE_GENERATOR_API_URL?: string;
  VITE_AGREEMENTS_API_URL?: string;
  VITE_FATURAMENTO_API_URL?: string;
  VITE_SUPABASE_URL?: string;
}

export function buildTracePropagationTargets(env: TracePropagationEnv): string[] {
  return [
    env.VITE_GENERATOR_API_URL,
    env.VITE_AGREEMENTS_API_URL,
    env.VITE_FATURAMENTO_API_URL,
    env.VITE_SUPABASE_URL,
  ].filter((url): url is string => Boolean(url));
}
